/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Not found
 * @export
 * @interface GetMarketsRegionIdTypesNotFound
 */
export interface GetMarketsRegionIdTypesNotFound {
    /**
     * Not found message
     * @type {string}
     * @memberof GetMarketsRegionIdTypesNotFound
     */
    error?: string;
}

/**
 * Check if a given object implements the GetMarketsRegionIdTypesNotFound interface.
 */
export function instanceOfGetMarketsRegionIdTypesNotFound(value: object): value is GetMarketsRegionIdTypesNotFound {
    return true;
}

export function GetMarketsRegionIdTypesNotFoundFromJSON(json: any): GetMarketsRegionIdTypesNotFound {
    return GetMarketsRegionIdTypesNotFoundFromJSONTyped(json, false);
}

export function GetMarketsRegionIdTypesNotFoundFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMarketsRegionIdTypesNotFound {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function GetMarketsRegionIdTypesNotFoundToJSON(json: any): GetMarketsRegionIdTypesNotFound {
    return GetMarketsRegionIdTypesNotFoundToJSONTyped(json, false);
}

export function GetMarketsRegionIdTypesNotFoundToJSONTyped(value?: GetMarketsRegionIdTypesNotFound | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

